import { FC, HTMLAttributes } from 'react';

type PontemWalletWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const PontemWallet: FC<PontemWalletWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 96 96"
      {...props}
    >
      <path
        fill="url(#paint0_linear)"
        d="M48 0C21.536 0 0 21.527 0 48c0 19.024 11.135 35.506 27.226 43.268v.03h.069A47.7 47.7 0 0 0 48 96c26.464 0 48-21.537 48-48S74.464 0 48 0m0 3.94c24.293 0 44.06 19.767 44.06 44.06 0 6.98-1.642 13.579-4.536 19.454-6.344-3.08-12.787-5.367-19.288-6.911V23.785c0-1.27-1.016-2.307-2.258-2.307H29.494c-1.251 0-2.258 1.036-2.258 2.307v36.924c-6.306 1.554-12.572 3.793-18.74 6.745A43.8 43.8 0 0 1 3.948 47.99C3.94 23.707 23.707 3.94 48 3.94M11.027 71.912a79 79 0 0 1 16.2-5.944V86.84a44.3 44.3 0 0 1-16.2-14.928M37.57 90.799V41.616c0-5.68 4.663-10.411 10.235-10.411 5.573 0 10.1 4.604 10.1 10.294 0 .04-.01.078-.01.117h.01v17.108c-4.752-.537-9.523-.733-14.284-.479l-3.93 5.69c6.11-.518 12.054-.47 17.92.186.049.01.107.01.156.01.04 0 .078.01.137.019 1.017.117 4.751.596 8.153 1.447l-8.153 2.766v22.554a44 44 0 0 1-9.893 1.133 43.7 43.7 0 0 1-10.44-1.25m30.667-3.685V66.056c5.553 1.398 11.057 3.441 16.57 6.12a44.4 44.4 0 0 1-16.57 14.938"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="47.999"
          x2="47.999"
          y1="98.094"
          y2="-14.719"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.086" stopColor="#8D29C1"></stop>
          <stop offset="0.238" stopColor="#942BBB"></stop>
          <stop offset="0.467" stopColor="#A92FAC"></stop>
          <stop offset="0.741" stopColor="#CA3793"></stop>
          <stop offset="1" stopColor="#F03F77"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PontemWallet;
